import { injectWebCss } from '../../utils/util';
import { Input } from './Input';
injectWebCss();
export default Input;
